import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressOverview = ({ user, progressData }) => {
  const { currentStreak, weeklyGoals, monthlyProgress, achievements } = progressData;

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-wellness">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-heading font-semibold text-foreground">Your Progress</h2>
        <button 
          onClick={() => window.location.href = '/progress-tracking'}
          className="text-primary hover:text-primary/80 transition-wellness text-sm font-medium"
        >
          View Details
        </button>
      </div>
      {/* Current Streak */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-primary/5 rounded-lg p-4 border border-primary/10">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
              <Icon name="Flame" size={20} color="white" />
            </div>
            <div>
              <p className="text-2xl font-heading font-bold text-primary">{currentStreak}</p>
              <p className="text-sm text-muted-foreground">Day Streak</p>
            </div>
          </div>
        </div>

        <div className="bg-accent/5 rounded-lg p-4 border border-accent/10">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center">
              <Icon name="Target" size={20} color="white" />
            </div>
            <div>
              <p className="text-2xl font-heading font-bold text-accent-foreground">{weeklyGoals?.completed}/{weeklyGoals?.total}</p>
              <p className="text-sm text-muted-foreground">Weekly Goals</p>
            </div>
          </div>
        </div>

        <div className="bg-success/5 rounded-lg p-4 border border-success/10">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-success rounded-full flex items-center justify-center">
              <Icon name="TrendingUp" size={20} color="white" />
            </div>
            <div>
              <p className="text-2xl font-heading font-bold text-success-foreground">{monthlyProgress}%</p>
              <p className="text-sm text-muted-foreground">Monthly Progress</p>
            </div>
          </div>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">Monthly Wellness Goal</span>
          <span className="text-sm text-muted-foreground">{monthlyProgress}% Complete</span>
        </div>
        <div className="w-full bg-muted rounded-full h-3">
          <div 
            className="bg-primary h-3 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${monthlyProgress}%` }}
          ></div>
        </div>
      </div>
      {/* Recent Achievements */}
      <div>
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Recent Achievements</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {achievements?.slice(0, 4)?.map((achievement, index) => (
            <div key={index} className="bg-muted/50 rounded-lg p-3 text-center border border-border hover:border-primary/20 transition-wellness">
              <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center mx-auto mb-2">
                <Icon name={achievement?.icon} size={16} color="white" />
              </div>
              <p className="text-xs font-medium text-foreground truncate">{achievement?.name}</p>
              <p className="text-xs text-muted-foreground">{achievement?.date}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressOverview;